import apiClient from '../../shared/auth/services'

export const userKanriService = {
  // Get user list
  async getPixUserList(data = {}) {
    const response = await apiClient.post('/getPixUserList', data)
    return response.data
  },

  // Get user count
  async getPixUserCount(mailAddress) {
    const response = await apiClient.post('/getPixUserCount', { mailAddress })
    return response.data
  },

  // Get pix-label user company count
  async getPixtagUserCompanyCount(serialNo) {
    const response = await apiClient.post('/getPixtagUserCompanyCount', { serialNo })
    return response.data
  },

  // Get pix-label user
  async getPixtagUser(serialNo) {
    const response = await apiClient.post('/getPixtagUser', { serialNo })
    return response.data
  },

  // Add new pix user
  async addPixUser(userData) {
    const response = await apiClient.post('/updatePixUser', {
      use_init: "true",
      action: "add",
      pageAction: "insert",
      userName: userData.userName,
      loginPassword: userData.loginPassword,
      mailAddress: userData.mailAddress,
      pixtagRiyoFlg: userData.pixtagRiyoFlg,
      riyoKyotenId: userData.riyoKyotenId,
      riyoKahi: userData.riyoKahi,
      riyoKengen: userData.riyoKengen,
      pixClientUsage: userData.pixClientUsage ?? 0,
      pixCameraUsage: userData.pixCameraUsage ?? 0,
      voiceRecognitionUsage: userData.voiceRecognitionUsage ?? 0,
      ocrUsage: userData.ocrUsage ?? 0,
      thetaCameraUsage: userData.thetaCameraUsage ?? 0
    })
    return response.data
  },

  // Update existing pix user
  async updatePixUser(userData) {
    const response = await apiClient.post('/updatePixUser', {
      use_init: "true",
      action: "add",
      pageAction: "update",
      pixUserId: userData.pixUserId,
      userName: userData.userName,
      loginPassword: userData.loginPassword,
      mailAddress: userData.mailAddress,
      pixtagRiyoFlg: userData.pixtagRiyoFlg,
      riyoKyotenId: userData.riyoKyotenId,
      riyoKahi: userData.riyoKahi,
      riyoKengen: userData.riyoKengen,
      pixClientUsage: userData.pixClientUsage ?? 0,
      pixCameraUsage: userData.pixCameraUsage ?? 0,
      voiceRecognitionUsage: userData.voiceRecognitionUsage ?? 0,
      ocrUsage: userData.ocrUsage ?? 0,
      thetaCameraUsage: userData.thetaCameraUsage ?? 0
    })
    return response.data
  },

  // Remove existing pix user
  async removePixUser(userData) {
    const response = await apiClient.post('/removePixUser', {
      use_init: "true",
      action: "add",
      pageAction: "update",
      pixUserId: userData.pixUserId,
      userName: userData.userName,
      loginPassword: userData.loginPassword,
      mailAddress: userData.mailAddress,
      pixtagRiyoFlg: userData.pixtagRiyoFlg,
      riyoKyotenId: userData.riyoKyotenId,
      riyoKahi: userData.riyoKahi,
      riyoKengen: userData.riyoKengen,
      pixClientUsage: userData.pixClientUsage ?? 0,
      pixCameraUsage: userData.pixCameraUsage ?? 0,
      voiceRecognitionUsage: userData.voiceRecognitionUsage ?? 0,
      ocrUsage: userData.ocrUsage ?? 0,
      thetaCameraUsage: userData.thetaCameraUsage ?? 0
    })
    return response.data
  },

  // Add pix renkei (link)
  async addPixRenkei(renkeiData) {
    const response = await apiClient.post('/addPixRenkei', {
      prePixId: renkeiData.prePixId,
      pixUserId: renkeiData.pixUserId
    })
    return response.data
  },

  // Get kyoten list
  async getKyotenList() {
    const response = await apiClient.post('/getKyotenList', {})
    return response.data
  },

  // Upload profile image
  async uploadProfileImage(formData) {
    const response = await apiClient.post('/uploadProfileImage', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000
    })
    return response.data
  },

  // Get profile image as blob with authentication
  async getProfileImage(pixUserId, profileImageId, filenameExtension) {
    const response = await apiClient.get('/getProfileImage', {
      params: {
        pixUserId,
        profileImageId,
        filenameExtension,
        type: 'thumb_comp',
        width: 88,
        height: 88
      },
      responseType: 'blob',
      headers: { Accept: 'image/jpeg' }
    })
    return response.data // Return blob data instead of blob URL
  },

  // Get company information
  async getCompanyInfo() {
    const response = await apiClient.post('/userKanri', {})
    return response.data
  },

  // Add pix client token (register UUID)
  async addPixClientToken(userData) {
    const response = await apiClient.post('/addPixClientToken', {
      pixUserId: userData.pixUserId,
      userName: userData.userName,
      mailAddress: userData.mailAddress
    })
    return response.data
  },

  // Get pix client token (cehck if token exists)
  async getPixClientToken() {
    const response = await apiClient.get('/getPixClientToken', {})
    return response.data
  }
}

export default userKanriService
